<div class="consumer-dimensions consumer-page consumer-new">
  <div class="consumer-left">
    <navbar current-id="'new'"></navbar>
  </div>

  <div class="consumer-main">Obsolete</div>

  <div class="consumer-bottom"></div>
</div>
